import { render, staticRenderFns } from "./ProjectConfigurationChanges.vue?vue&type=template&id=22924548&scoped=true&"
import script from "./ProjectConfigurationChanges.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22924548",
  null
  
)

export default component.exports